var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { Form } from '@tribeplatform/react-components/Form';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { getIcon } from '../Button/utils.js';
import { MarkdownBlock } from '../Markdown/Block.js';
export const InputBlock = forwardRef((props, ref) => {
    const { copy, value: defaultValue, helperText: markdownHelperText, leadingIcon, children: nonArrayChildren } = props, rest = __rest(props, ["copy", "value", "helperText", "leadingIcon", "children"]);
    const children = React.Children.toArray(nonArrayChildren);
    const formContext = useFormContext();
    const { control: enabled, watch } = formContext || {};
    const value = enabled ? watch(rest.name, defaultValue) : defaultValue;
    const helperText = typeof markdownHelperText === 'string' ? (React.createElement(MarkdownBlock, { text: markdownHelperText })) : (markdownHelperText);
    const additionalProps = enabled ? {} : { value };
    if (copy) {
        const Component = enabled ? Form.InputCopy : FormControl.InputCopy;
        return (React.createElement(Component, Object.assign({}, rest, additionalProps, { helperText: helperText, defaultValue: value })));
    }
    const Component = enabled ? Form.Input : FormControl.Input;
    return (React.createElement(Component, Object.assign({}, rest, additionalProps, { ref: ref, helperText: helperText, defaultValue: value, trailingAddon: (children === null || children === void 0 ? void 0 : children.length) ? children : undefined, leadingIcon: getIcon(leadingIcon) })));
});
//# sourceMappingURL=Block.js.map